import { render, staticRenderFns } from "./PhoneDetail.vue?vue&type=template&id=a4fd777a&"
import script from "./PhoneDetail.vue?vue&type=script&lang=js&"
export * from "./PhoneDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports